import React, { useEffect, useState } from "react";

const STORAGE_KEY = "mixmind_beta_access";
const ACCESS_CODE = "ZANE";

export function BetaAccessGate() {
  const [hasAccess, setHasAccess] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [checkedStorage, setCheckedStorage] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === "granted") {
        setHasAccess(true);
      }
      setCheckedStorage(true);
    } catch (e) {
      // ignore storage errors in non-browser contexts
      setCheckedStorage(true);
    }
  }, []);

  if (!checkedStorage || hasAccess) return null;

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const normalized = code.trim().toUpperCase();
    if (normalized === ACCESS_CODE) {
      try {
        localStorage.setItem(STORAGE_KEY, "granted");
      } catch (err) {
        // ignore storage issues; access granted for this session
      }
      setHasAccess(true);
      setError(null);
      return;
    }
    setError("Code incorrect. Réessaie.");
  }

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-slate-900/70 backdrop-blur">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-xl dark:border-slate-700 dark:bg-slate-900">
        <div className="space-y-2 mb-4">
          <p className="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Pré-version
          </p>
          <h2 className="text-2xl font-semibold text-slate-900 dark:text-white">Accès MixMind (beta)</h2>
          <p className="text-sm text-slate-600 dark:text-slate-300">
            Ce site est en pré-version. Merci de saisir le code d&apos;accès pour continuer.
          </p>
        </div>

        <form className="space-y-3" onSubmit={handleSubmit}>
          <div className="space-y-1">
            <label className="text-xs font-medium text-slate-600 dark:text-slate-300" htmlFor="beta-code">
              Code d&apos;accès
            </label>
            <input
              id="beta-code"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:focus:border-blue-400 dark:focus:ring-blue-900/50"
              placeholder="Entrez le code fourni"
              autoFocus
            />
            {error && <p className="text-xs text-red-600 dark:text-red-400">{error}</p>}
          </div>

          <div className="flex items-center justify-end gap-2">
            <button
              type="submit"
              className="inline-flex items-center gap-2 rounded-full bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-1 focus:ring-offset-white dark:focus:ring-offset-slate-900"
            >
              Valider
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default BetaAccessGate;
